import { Helmet } from "react-helmet-async";

type HeadProps = {
  title?: string;
  description?: string;
};

export const Head = ({
  title = "",
  description = "Partner Portal OTP Bank",
}: HeadProps = {}) => {
  return (
    <Helmet
      title={title ? `${title} | Partner Portal` : undefined}
      defaultTitle="Partner Portal"
    >
      <meta name="description" content={description} />
    </Helmet>
  );
};
